

















































import Component from 'vue-class-component';
import Vue from 'vue';
import {trans} from "../../plagins/translate";
import {Kt, Record} from '../interfaces'
import {State} from "../store";

@Component({
    components: {},
    props: [
        'record',
        'index'
    ],
})
export default class Template1 extends Vue {

    state: State | any = {};
    record!: Record;
    index!: number;

    trans(s: string): string {
        return trans(s);
    }

    subtractTime(time: string): string {
        let timeSplit = time.split(':');
        let hours: number = parseInt(timeSplit[0]);
        let minutes: number = parseInt(timeSplit[1]);
        let seconds: number = parseInt(timeSplit[2]);
        let date1: Date = new Date(2000, 1, 1, hours, minutes, seconds);

        timeSplit = this.state.first_record.all_kts[this.state.fields.selected_kt_setting.id].value.split(':');
        hours = parseInt(timeSplit[0]);
        minutes = parseInt(timeSplit[1]);
        seconds = parseInt(timeSplit[2]);
        let date2: Date = new Date(2000, 1, 1, hours, minutes, seconds);

        let date3 = new Date(date1.getTime() - date2.getTime() + new Date(2000, 1, 1).getTime());
        return date3.toTimeString().split(' ')[0].toString()
    }

    getKtTitle(kt: Kt) {
        return this.state.settings.columns[kt.id].title;
    }

    created(): void {
        this.state = this.$store.state;
    }


}
